/* Size row on the product card — click a size to add that variant to cart.

   Design 5527:10512 / 5660:8365. Desktop hover only; the row is CSS-hidden at rest.

   Mirrors what Madrid's own product-form.js does on submit (assets/product-form.js
   lines 29-155) so the cart drawer behaves identically: same fetchConfig, the same
   `sections` / `sections_url` payload the drawer needs to re-render, and the same
   cart.renderContents(response) to refresh and open it.

   One delegated listener rather than a <product-form> per size: six forms on each of
   32 cards would be ~192 forms per page. No core JS edit either way. */

(function () {
  'use strict';

  var SELECTOR = '[data-stl-add-variant]';

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(SELECTOR);
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-stl-add-variant');
    if (!variantId) return;

    event.preventDefault();

    /* Guard against a double-tap queueing two adds while the first is in flight. */
    if (button.hasAttribute('aria-busy')) return;
    button.setAttribute('aria-busy', 'true');

    var cart = getCart();

    /* fetchConfig and routes are Madrid globals from global.js / theme.liquid. If either
       is missing the theme has changed underneath us — fall back to the PDP rather than
       silently doing nothing. */
    if (typeof fetchConfig !== 'function' || typeof routes === 'undefined') {
      var url = button.getAttribute('data-stl-product-url');
      if (url) window.location = url + '?variant=' + variantId;
      button.removeAttribute('aria-busy');
      return;
    }

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          document.dispatchEvent(new CustomEvent('cart:error', {
            detail: {
              source: 'stl-card-size-add',
              productVariantId: variantId,
              errors: response.description,
              message: response.message
            }
          }));
          return;
        }
        if (cart) cart.renderContents(response);
      })
      .catch(function (e) { console.error(e); })
      .finally(function () { button.removeAttribute('aria-busy'); });
  });
})();
